var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "btn btn-primary",
      attrs: {
        href: "/Template/" + _vm.templateId + "/Preview/Browser",
        target: "_blank"
      }
    },
    [
      _vm._v(
        "\n    " +
          _vm._s(_vm.resource("Template_BrowserPreviewButton_DisplayText")) +
          "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }